import { Component, OnInit, AfterViewInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfigColumn, TypeColumn } from '@eqproject/eqp-table';
import { TranslateService } from '@ngx-translate/core';
import { UserDTO } from '../../models/user.model';
import { VersioneDTO } from '../../models/versione.model';
import { AuthService } from '../../services/auth.service';
import { DialogService } from '../../services/dialog.service';
import { UtilityService } from '../../services/utility.service';
import { VersioneService } from '../../services/versione.service';

@Component({
  selector: 'app-help',
  templateUrl: './help.component.html',
  styleUrls: ['./help.component.scss']
})
export class HelpComponent implements OnInit {

  public currentUser: UserDTO;
  allVersions: Array<VersioneDTO> = new Array<VersioneDTO>();
  columns: Array<ConfigColumn>;
  routeParams: any;
  genericHelp: boolean;
  LIST_COMPANIES = "/registry/list-companies";
  MANAGE_COMPANIES = "/registry/manage-companies";
  constArray = [this.LIST_COMPANIES, this.MANAGE_COMPANIES]

  constructor(
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute,
    public translate: TranslateService,
    private versioneService: VersioneService,
    private utilityService : UtilityService) {

  }

  async ngOnInit() {
    this.utilityService.clearQueryParameters(this.route, this.router);
    this.currentUser = this.authService.getCurrentUser();
    this.configureColumns();
    this.reloadVersions();

    //Recupera dall'url il parametro che rappresenta la rotta di provenienza.
    // Se questo parametro non è presente nell'array di costanti, viene visualizzato una schermata Help generica
    this.route.queryParams
      .subscribe(params => {
        this.routeParams = params.route;
        if (this.constArray.includes(this.routeParams)) {
          this.genericHelp = false;
        }
      });
  }

  /**
  * Creazione colonne della tabella
  **/
  configureColumns() {
    this.columns = [
      {
        key: "action", display: "",
        type: TypeColumn.MenuAction, buttonMenuIcon: "expand_more",
        styles: { flex: "0 0 7%" },
        actions: [
          {
            name: this.translate.instant("GENERIC_LABEL.EDIT"),
            icon: "edit",
            fn: (element) => this.editRow(element), hidden: (element) => this.currentUser.FK_Company != 3
          },
          {
            name: this.translate.instant("GENERIC_LABEL.DELETE"),
            icon: "delete",
            fn: (element) => this.deleteRow(element), hidden: (element) => this.currentUser.FK_Company != 3
          }
        ]
      },
      { key: "ProductName", display: this.translate.instant("GENERIC_FIELDS.PRODUCT_NAME") },
      { key: "VersionNumber", display: this.translate.instant("GENERIC_FIELDS.VERSION") },
      {
        key: "ReleaseNotes", display: this.translate.instant("GENERIC_FIELDS.RELEASE_NOTES"),
        type: TypeColumn.SimpleAction,
        actions: [
          { name: '', fontawesome: true, icon: "fa fa-download", fn: (element, col, elementIndex) => this.viewReleaseNotesLink(element), hidden: (element) => { return element.ReleaseNotes == null || element.ReleaseNotes == ''; } },
        ]
      }
    ]
  }

  /**
  * Modifica o visualizza riga della tabella
  * @param element
  **/
  editRow(element) {
    this.router.navigate(['../add-versions', element.ID]);
  }

  /**
  * Elimina riga della tabella
  * @param element
  **/
  deleteRow(element) {
    const elementToDelete: VersioneDTO = element;

    DialogService.Confirm(this.translate.instant("DIALOGS.DELETE_CONFIRM"), () => {
      this.versioneService.deleteVersione(elementToDelete.ID)
        .then((res) => {
          DialogService.Success(this.translate.instant("DIALOGS.DELETE_SUCCESS"));
          this.reloadVersions();
        })
        .catch((err) => {
          DialogService.Error(err.message);
        });
    }, true);
  }

  /**
  * Ricarico i dati della tabella
  **/
  reloadVersions() {
    this.versioneService.getAllVersions()
      .then((res) => {
        this.allVersions = new Array<VersioneDTO>();
        this.allVersions = res;
      })
      .catch((err) => {
        DialogService.Error(err.message);
      });
  }

  /**
  * Apre il link delle note di rilascio
  **/
  viewReleaseNotesLink(element) {
    window.open(element.ReleaseNotes, '_blank');
  }

}
